var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReddit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    display: "block",
    role: "presentation",
    viewBox: "0 0 83 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 17.252 23.461 L 12.66 23.461 L 12.66 21.51 L 12.523 21.51 C 11.334 23.033 9.49 23.703 7.536 23.703 C 2.867 23.703 0 19.975 0 15.267 C 0 10.558 3.067 6.842 7.69 6.842 C 9.567 6.842 11.003 7.36 12.328 8.624 L 12.422 8.624 L 12.438 0 L 17.252 0 Z M 8.658 10.982 C 6.296 10.982 4.644 12.849 4.644 15.267 C 4.644 17.684 6.296 19.551 8.658 19.551 C 9.78 19.551 10.736 19.134 11.436 18.435 L 12.511 19.551 L 12.673 19.551 L 12.673 15.267 C 12.673 12.849 11.02 10.983 8.658 10.982 Z",
    fill: "rgb(7, 16, 12)",
    height: "23.703125px",
    id: "esus2EyjI",
    transform: "translate(27.283 0.297)",
    width: "17.252000000000002px"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 17.253 23.461 L 12.66 23.461 L 12.66 21.51 L 12.524 21.51 C 11.335 23.033 9.491 23.703 7.537 23.703 C 2.868 23.703 0 19.975 0 15.267 C 0 10.558 3.067 6.842 7.69 6.842 C 9.567 6.842 11.004 7.36 12.329 8.624 L 12.423 8.624 L 12.44 0 L 17.253 0 Z M 8.629 10.982 C 6.267 10.982 4.614 12.849 4.614 15.267 C 4.614 17.684 6.267 19.551 8.629 19.551 C 9.746 19.551 10.706 19.134 11.407 18.435 L 12.481 19.551 L 12.644 19.551 L 12.644 15.267 C 12.644 12.849 10.991 10.983 8.629 10.982 Z",
    fill: "rgb(7, 16, 12)",
    height: "23.703125px",
    id: "SU_6wmnf7",
    transform: "translate(45.699 0.297)",
    width: "17.252900000000004px"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.119 0 C 12.529 0 15.686 3.216 15.686 7.737 C 15.686 8.53 15.609 9.277 15.443 9.989 L 4.397 9.989 C 4.903 11.711 6.394 13.052 8.637 13.052 C 9.873 13.052 11.628 12.61 12.575 11.881 L 14.07 15.474 C 12.681 16.419 10.562 16.874 8.701 16.874 C 3.493 16.878 0 13.527 0 8.483 C 0 3.745 3.251 0 8.119 0 Z M 8.051 3.758 C 6.071 3.762 4.729 5.039 4.3 6.974 L 11.241 6.974 C 11.241 4.87 9.805 3.758 8.051 3.758 Z",
    fill: "rgb(7, 16, 12)",
    height: "16.87403394307086px",
    id: "FsEXD_wyZ",
    transform: "translate(10.663 7.122)",
    width: "15.685500000000001px"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.733 0 C 10.528 0.004 11.288 0.157 11.594 0.339 L 9.656 4.937 C 9.41 4.814 8.832 4.678 8.284 4.678 C 7.736 4.678 7.184 4.814 6.653 5.072 C 5.6 5.607 4.822 6.672 4.822 8.212 L 4.822 16.636 L 0 16.636 L 0 0.245 L 4.686 0.245 L 4.686 2.545 L 4.775 2.545 C 5.876 1.082 7.554 0 9.733 0 Z",
    fill: "rgb(7, 16, 12)",
    height: "16.635740000000002px",
    id: "W3aPOXWYG",
    transform: "translate(0 7.118)",
    width: "11.5938px"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 4.822 16.391 L 0 16.391 L 0 0 L 4.822 0 Z",
    fill: "rgb(7, 16, 12)",
    height: "16.390620000000002px",
    id: "CBV2g8juD",
    transform: "translate(65.306 7.363)",
    width: "4.822199999999995px"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.33 4.454 L 11.856 4.454 L 11.856 8.551 L 8.33 8.551 L 8.33 20.844 L 3.509 20.844 L 3.509 8.551 L 0 8.551 L 0 4.454 L 3.509 4.454 L 3.509 0 L 8.33 0 Z",
    fill: "rgb(7, 16, 12)",
    height: "20.84374px",
    id: "E8OnilaQE",
    transform: "translate(71.147 2.91)",
    width: "11.856400000000008px"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 2.944 0 C 4.563 0 5.889 1.323 5.889 2.939 C 5.889 4.556 4.563 5.879 2.944 5.879 C 1.326 5.879 0 4.556 0 2.939 C 0 1.323 1.326 0 2.944 0 Z",
    fill: "rgb(7, 16, 12)",
    height: "5.87891px",
    id: "IUF_2vEbx",
    transform: "translate(64.774 0)",
    width: "5.8887px"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReddit);
export default __webpack_public_path__ + "static/media/reddit.7485b03f98741a1d7476b64449fcda5f.svg";
export { ForwardRef as ReactComponent };